'use client'
import { useEffect, useState } from 'react'

/**
 * Returns true once the window has scrolled past `threshold` px from the top.
 * Used to swap the navbar from transparent (over the hero) to backdrop-blurred
 * (over content) without re-rendering on every scroll event.
 */
export function useScrolled(threshold = 24) {
  const [scrolled, setScrolled] = useState(false)
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [threshold])
  return scrolled
}
